import { urlAPI, axiosInstance } from "./config";

export default {
  state: {
    Categorie: {},
    AllCategories: [],
  },
  mutations: {
    SetCategorie(state, payload) {
      state.Categorie = payload;
    },
    SetAllCategories(state, payload) {
      state.AllCategories = payload;
    },
  },
  actions: {
    async LoadCategorieEmpty({ commit }) {
      commit("SetCategorie", {});
    },
    async LoadCategorie({ commit }, payload) {
      let data = await axiosInstance.get(urlAPI + `/category/${payload}`);
      commit("SetCategorie", data?.data?.data);
    },
    async LoadCategorieLink_name({ commit }, payload) {
      return await axiosInstance
        .get(urlAPI + `/category/link_name/${payload}`)
        .then(function (data) {
          commit("SetCategorie", data?.data?.data);
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async LoadAllCategories({ commit }) {
      let responce = await axiosInstance.get(urlAPI + "/category");
      /* console.log(responce.data.data); */
      commit("SetAllCategories", responce?.data?.data);
    },
  },
  getters: {
    getCategorie: (state) => state.Categorie,
    getAllCategories: (state) => state.AllCategories,
  },
};
